// AUTO-GENERATED-STYLE static manifest. Complete WarpDrive schema registration
// set for the WarpDrive store flip (Phase 2.6+). This module imports EVERY
// resource schema, EVERY extension, and EVERY trait defined under
// addons/tio-data/src/data/, so that an app registering this set materializes
// ALL resource types from schemas (no fallback to the legacy compat Model
// class in tio-data/models, which is being removed).
//
// The list is alphabetized and mechanically generated from the data/resources
// + data/traits directories; keep it that way. To regenerate after adding a
// resource: glob data/resources/*.{schema,ext}.ts + data/traits/*.{schema,ext}.ts
// (trait *.ext.ts files register object extensions — e.g. digital-asset.ext —
// and MUST be included, or trait getters silently drop off records at runtime).
//
// Counts: 182 schemas, 69 extensions, 3 traits.
import accountSchema from 'tio-data/data/resources/account.schema';
import accountTransactionSchema from 'tio-data/data/resources/account-transaction.schema';
import accountingInvoiceSchema from 'tio-data/data/resources/accounting-invoice.schema';
import accountingLineItemSchema from 'tio-data/data/resources/accounting-line-item.schema';
import accountingPaymentSchema from 'tio-data/data/resources/accounting-payment.schema';
import accountingReturnSchema from 'tio-data/data/resources/accounting-return.schema';
import accountingTransactionSchema from 'tio-data/data/resources/accounting-transaction.schema';
import agentSchema from 'tio-data/data/resources/agent.schema';
import aggregationAccountSchema from 'tio-data/data/resources/aggregation-account.schema';
import aggregationLoanChangeLogSchema from 'tio-data/data/resources/aggregation-loan-change-log.schema';
import aggregationLoanForgivenessObservationSchema from 'tio-data/data/resources/aggregation-loan-forgiveness-observation.schema';
import aggregationUserSchema from 'tio-data/data/resources/aggregation-user.schema';
import agreementSchema from 'tio-data/data/resources/agreement.schema';
import aiRecommendationSchema from 'tio-data/data/resources/ai-recommendation.schema';
import answerProfileSchema from 'tio-data/data/resources/answer-profile.schema';
import approvableSchema from 'tio-data/data/resources/approvable.schema';
import assetSummarySchema from 'tio-data/data/resources/asset-summary.schema';
import attachmentSchema from 'tio-data/data/resources/attachment.schema';
import auditLogSchema from 'tio-data/data/resources/audit-log.schema';
import auditQueueSchema from 'tio-data/data/resources/audit-queue.schema';
import authenticationLogSchema from 'tio-data/data/resources/authentication-log.schema';
import bankTransactionSchema from 'tio-data/data/resources/bank-transaction.schema';
import bulkAchPaymentSchema from 'tio-data/data/resources/bulk-ach-payment.schema';
import caffeinateCampaignSchema from 'tio-data/data/resources/caffeinate-campaign.schema';
import caffeinateCampaignSubscriptionSchema from 'tio-data/data/resources/caffeinate-campaign-subscription.schema';
import caffeinateMailingSchema from 'tio-data/data/resources/caffeinate-mailing.schema';
import commandSchema from 'tio-data/data/resources/command.schema';
import commentSchema from 'tio-data/data/resources/comment.schema';
import commentableSchema from 'tio-data/data/resources/commentable.schema';
import companySchema from 'tio-data/data/resources/company.schema';
import companyLpnSettingSchema from 'tio-data/data/resources/company-lpn-setting.schema';
import companySettingSchema from 'tio-data/data/resources/company-setting.schema';
import componentReviewCommentSchema from 'tio-data/data/resources/component-review-comment.schema';
import componentReviewThreadSchema from 'tio-data/data/resources/component-review-thread.schema';
import conditionSchema from 'tio-data/data/resources/condition.schema';
import conditionableSchema from 'tio-data/data/resources/conditionable.schema';
import contributionSchema from 'tio-data/data/resources/contribution.schema';
import creditorSchema from 'tio-data/data/resources/creditor.schema';
import customCompanyEmailTemplateSchema from 'tio-data/data/resources/custom-company-email-template.schema';
import dapipInstitutionCampusViewSchema from 'tio-data/data/resources/dapip-institution-campus-view.schema';
import dependentSchema from 'tio-data/data/resources/dependent.schema';
import digitalAssetSchema from 'tio-data/data/resources/digital-asset.schema';
import eligibilityFileJobLogSchema from 'tio-data/data/resources/eligibility-file-job-log.schema';
import eligibilityConditionSchema from 'tio-data/data/resources/eligibility-condition.schema';
import eligibilityFileJobLogEntrySchema from 'tio-data/data/resources/eligibility-file-job-log-entry.schema';
import emailAddressSchema from 'tio-data/data/resources/email-address.schema';
import emailTemplateSchema from 'tio-data/data/resources/email-template.schema';
import employeeSchema from 'tio-data/data/resources/employee.schema';
import employeeAdditionSchema from 'tio-data/data/resources/employee-addition.schema';
import employeePlanAccountSchema from 'tio-data/data/resources/employee-plan-account.schema';
import employeeVersionSchema from 'tio-data/data/resources/employee-version.schema';
import enumSchema from 'tio-data/data/resources/enum.schema';
import enumPatternSchema from 'tio-data/data/resources/enum-pattern.schema';
import evaluationSchema from 'tio-data/data/resources/evaluation.schema';
import familySchema from 'tio-data/data/resources/family.schema';
import familyInviteSchema from 'tio-data/data/resources/family-invite.schema';
import fieldableSchema from 'tio-data/data/resources/fieldable.schema';
import fileHistorySchema from 'tio-data/data/resources/file-history.schema';
import fileHistoryLogSchema from 'tio-data/data/resources/file-history-log.schema';
import financialInstitutionSchema from 'tio-data/data/resources/financial-institution.schema';
import financialInstitutionPatternSchema from 'tio-data/data/resources/financial-institution-pattern.schema';
import genericRelationshipSchema from 'tio-data/data/resources/generic-relationship.schema';
import incomingEmailLogSchema from 'tio-data/data/resources/incoming-email-log.schema';
import inviteSchema from 'tio-data/data/resources/invite.schema';
import invoiceSchema from 'tio-data/data/resources/invoice.schema';
import invoiceLineItemSchema from 'tio-data/data/resources/invoice-line-item.schema';
import ledgerAccountSchema from 'tio-data/data/resources/ledger-account.schema';
import ledgerEntrySchema from 'tio-data/data/resources/ledger-entry.schema';
import ledgerEventSchema from 'tio-data/data/resources/ledger-event.schema';
import legacyAuthorizationResourceUserRelationshipTypeSchema from 'tio-data/data/resources/legacy-authorization-resource-user-relationship-type.schema';
import limitSchema from 'tio-data/data/resources/limit.schema';
import limitLedgerEntrySchema from 'tio-data/data/resources/limit-ledger-entry.schema';
import loanSchema from 'tio-data/data/resources/loan.schema';
import loanResolutionSchema from 'tio-data/data/resources/loan-resolution.schema';
import loginSchema from 'tio-data/data/resources/login.schema';
import lpnPageSchema from 'tio-data/data/resources/lpn-page.schema';
import matchAssetSchema from 'tio-data/data/resources/match-asset.schema';
import matchCertificationSchema from 'tio-data/data/resources/match-certification.schema';
import matchParticipantSchema from 'tio-data/data/resources/match-participant.schema';
import matchPaymentSchema from 'tio-data/data/resources/match-payment.schema';
import matchPeriodSchema from 'tio-data/data/resources/match-period.schema';
import matchPlanSchema from 'tio-data/data/resources/match-plan.schema';
import matchPlanRetirementPlanSchema from 'tio-data/data/resources/match-plan-retirement-plan.schema';
import messageSchema from 'tio-data/data/resources/message.schema';
import messageReceiptSchema from 'tio-data/data/resources/message-receipt.schema';
import messageableSchema from 'tio-data/data/resources/messageable.schema';
import notificationHistorySchema from 'tio-data/data/resources/notification-history.schema';
import observableSchema from 'tio-data/data/resources/observable.schema';
import observableAssetSchema from 'tio-data/data/resources/observable-asset.schema';
import observableDocumentSchema from 'tio-data/data/resources/observable-document.schema';
import observableDocumentLogSchema from 'tio-data/data/resources/observable-document-log.schema';
import observationSchema from 'tio-data/data/resources/observation.schema';
import observationDocumentSchema from 'tio-data/data/resources/observation-document.schema';
import ownerSchema from 'tio-data/data/resources/owner.schema';
import partnerPolicySchema from 'tio-data/data/resources/partner-policy.schema';
import paymentReturnSchema from 'tio-data/data/resources/payment-return.schema';
import paymentTransactionSchema from 'tio-data/data/resources/payment-transaction.schema';
import pcsAuthorizationSchema from 'tio-data/data/resources/pcs-authorization.schema';
import pcsCardSchema from 'tio-data/data/resources/pcs-card.schema';
import pcsCardEventSchema from 'tio-data/data/resources/pcs-card-event.schema';
import pcsCardHolderSchema from 'tio-data/data/resources/pcs-card-holder.schema';
import pcsCompanySchema from 'tio-data/data/resources/pcs-company.schema';
import pcsCompanyLoadSchema from 'tio-data/data/resources/pcs-company-load.schema';
import pcsDisputeSchema from 'tio-data/data/resources/pcs-dispute.schema';
import pcsLogicalCardUsageSchema from 'tio-data/data/resources/pcs-logical-card-usage.schema';
import pcsMerchantSchema from 'tio-data/data/resources/pcs-merchant.schema';
import pcsMerchantNetworkMerchantSchema from 'tio-data/data/resources/pcs-merchant-network-merchant.schema';
import pcsNetworkMerchantSchema from 'tio-data/data/resources/pcs-network-merchant.schema';
import pcsNetworkMerchantDetailSchema from 'tio-data/data/resources/pcs-network-merchant-detail.schema';
import pcsProgramSchema from 'tio-data/data/resources/pcs-program.schema';
import pcsProgramSettingSchema from 'tio-data/data/resources/pcs-program-setting.schema';
import pcsProviderSchema from 'tio-data/data/resources/pcs-provider.schema';
import pcsProviderLoadSchema from 'tio-data/data/resources/pcs-provider-load.schema';
import pcsProviderSettingSchema from 'tio-data/data/resources/pcs-provider-setting.schema';
import pcsTransactionSchema from 'tio-data/data/resources/pcs-transaction.schema';
import personSchema from 'tio-data/data/resources/person.schema';
import phoneNumberSchema from 'tio-data/data/resources/phone-number.schema';
import planSchema from 'tio-data/data/resources/plan.schema';
import planAuditPeriodSchema from 'tio-data/data/resources/plan-audit-period.schema';
import planAuditScheduleSchema from 'tio-data/data/resources/plan-audit-schedule.schema';
import postalAddressSchema from 'tio-data/data/resources/postal-address.schema';
import postalAddressableSchema from 'tio-data/data/resources/postal-addressable.schema';
import profileAttributeSchema from 'tio-data/data/resources/profile-attribute.schema';
import pslfAssetSchema from 'tio-data/data/resources/pslf-asset.schema';
import pslfFieldSchema from 'tio-data/data/resources/pslf-field.schema';
import pslfFormSchema from 'tio-data/data/resources/pslf-form.schema';
import pslfFormVersionSchema from 'tio-data/data/resources/pslf-form-version.schema';
import pslfGroupSchema from 'tio-data/data/resources/pslf-group.schema';
import pslfProfileSchema from 'tio-data/data/resources/pslf-profile.schema';
import pslfTemplateSchema from 'tio-data/data/resources/pslf-template.schema';
import publicAssetSchema from 'tio-data/data/resources/public-asset.schema';
import rawFileDigitalAssetSchema from 'tio-data/data/resources/raw-file-digital-asset.schema';
import recommendationSchema from 'tio-data/data/resources/recommendation.schema';
import remoteEventSchema from 'tio-data/data/resources/remote-event.schema';
import reportTrackingSchema from 'tio-data/data/resources/report-tracking.schema';
import reportsSchema from 'tio-data/data/resources/reports.schema';
import roleViewSchema from 'tio-data/data/resources/role-view.schema';
import scheduleSchema from 'tio-data/data/resources/schedule.schema';
import scholarshipSchema from 'tio-data/data/resources/scholarship.schema';
import searchSchema from 'tio-data/data/resources/search.schema';
import searchDataPointSchema from 'tio-data/data/resources/search-data-point.schema';
import searchDataSetSchema from 'tio-data/data/resources/search-data-set.schema';
import searchDataSetMemberSchema from 'tio-data/data/resources/search-data-set-member.schema';
import searchDataSetMemberFieldSchema from 'tio-data/data/resources/search-data-set-member-field.schema';
import searchIndexDefinitionSchema from 'tio-data/data/resources/search-index-definition.schema';
import sqlDatasetSchema from 'tio-data/data/resources/sql-dataset.schema';
import strategyFinderResultSchema from 'tio-data/data/resources/strategy-finder-result.schema';
import tagSchema from 'tio-data/data/resources/tag.schema';
import taggableSchema from 'tio-data/data/resources/taggable.schema';
import tasApplicationSchema from 'tio-data/data/resources/tas-application.schema';
import tasApprovableSchema from 'tio-data/data/resources/tas-approvable.schema';
import tasAssetSchema from 'tio-data/data/resources/tas-asset.schema';
import tasAssistanceSchema from 'tio-data/data/resources/tas-assistance.schema';
import tasCourseSchema from 'tio-data/data/resources/tas-course.schema';
import tasDispatchSchema from 'tio-data/data/resources/tas-dispatch.schema';
import tasEligibilitySchema from 'tio-data/data/resources/tas-eligibility.schema';
import tasFieldSchema from 'tio-data/data/resources/tas-field.schema';
import tasFieldOptionSchema from 'tio-data/data/resources/tas-field-option.schema';
import tasGroupSchema from 'tio-data/data/resources/tas-group.schema';
import tasGroupingSchema from 'tio-data/data/resources/tas-grouping.schema';
import tasInvoiceSchema from 'tio-data/data/resources/tas-invoice.schema';
import tasParticipantSchema from 'tio-data/data/resources/tas-participant.schema';
import tasPaymentSchema from 'tio-data/data/resources/tas-payment.schema';
import tasPaymentAssistanceRecordSchema from 'tio-data/data/resources/tas-payment-assistance-record.schema';
import tasProgramInstanceSchema from 'tio-data/data/resources/tas-program-instance.schema';
import tasProgramInstanceVersionSchema from 'tio-data/data/resources/tas-program-instance-version.schema';
import tasProgramLimitSchema from 'tio-data/data/resources/tas-program-limit.schema';
import tasProgramTemplateSchema from 'tio-data/data/resources/tas-program-template.schema';
import tasProgramTemplateInstitutionSchema from 'tio-data/data/resources/tas-program-template-institution.schema';
import tasProgramTemplateVersionSchema from 'tio-data/data/resources/tas-program-template-version.schema';
import tasUnaccreditedInstitutionSchema from 'tio-data/data/resources/tas-unaccredited-institution.schema';
import tasUnifiedInstitutionSchema from 'tio-data/data/resources/tas-unified-institution.schema';
import thoughtBubbleFlowSchema from 'tio-data/data/resources/thought-bubble-flow.schema';
import thoughtBubbleFlowInvocationSchema from 'tio-data/data/resources/thought-bubble-flow-invocation.schema';
import thoughtBubbleStepSchema from 'tio-data/data/resources/thought-bubble-step.schema';
import tierSchema from 'tio-data/data/resources/tier.schema';
import tuitionAssistanceConfigSchema from 'tio-data/data/resources/tuition-assistance-config.schema';
import userSchema from 'tio-data/data/resources/user.schema';
import userRelationshipSchema from 'tio-data/data/resources/user-relationship.schema';
import userRoleSchema from 'tio-data/data/resources/user-role.schema';
import wellnessInsightsComponentDefinitionSchema from 'tio-data/data/resources/wellness-insights-component-definition.schema';
import wellnessTrainSchema from 'tio-data/data/resources/wellness-train.schema';
import workspaceSchema from 'tio-data/data/resources/workspace.schema';

import accountExt from 'tio-data/data/resources/account.ext';
import accountTransactionExt from 'tio-data/data/resources/account-transaction.ext';
import accountingInvoiceExt from 'tio-data/data/resources/accounting-invoice.ext';
import accountingLineItemExt from 'tio-data/data/resources/accounting-line-item.ext';
import accountingPaymentExt from 'tio-data/data/resources/accounting-payment.ext';
import agentExt from 'tio-data/data/resources/agent.ext';
import aiRecommendationExt from 'tio-data/data/resources/ai-recommendation.ext';
import answerProfileExt from 'tio-data/data/resources/answer-profile.ext';
import assetSummaryExt from 'tio-data/data/resources/asset-summary.ext';
import attachmentExt from 'tio-data/data/resources/attachment.ext';
import bankTransactionExt from 'tio-data/data/resources/bank-transaction.ext';
import caffeinateMailingExt from 'tio-data/data/resources/caffeinate-mailing.ext';
import commandExt from 'tio-data/data/resources/command.ext';
import commentExt from 'tio-data/data/resources/comment.ext';
import companyLpnSettingExt from 'tio-data/data/resources/company-lpn-setting.ext';
import companySettingExt from 'tio-data/data/resources/company-setting.ext';
import componentReviewThreadExt from 'tio-data/data/resources/component-review-thread.ext';
import conditionExt from 'tio-data/data/resources/condition.ext';
import dependentExt from 'tio-data/data/resources/dependent.ext';
import digitalAssetExt from 'tio-data/data/traits/digital-asset.ext';
import eligibilityFileJobLogExt from 'tio-data/data/resources/eligibility-file-job-log.ext';
import emailAddressExt from 'tio-data/data/resources/email-address.ext';
import employeeExt from 'tio-data/data/resources/employee.ext';
import employeeAdditionExt from 'tio-data/data/resources/employee-addition.ext';
import evaluationExt from 'tio-data/data/resources/evaluation.ext';
import familyExt from 'tio-data/data/resources/family.ext';
import inviteExt from 'tio-data/data/resources/invite.ext';
import invoiceExt from 'tio-data/data/resources/invoice.ext';
import loanExt from 'tio-data/data/resources/loan.ext';
import loanResolutionExt from 'tio-data/data/resources/loan-resolution.ext';
import loginExt from 'tio-data/data/resources/login.ext';
import lpnPageExt from 'tio-data/data/resources/lpn-page.ext';
import matchParticipantExt from 'tio-data/data/resources/match-participant.ext';
import matchPlanExt from 'tio-data/data/resources/match-plan.ext';
import notificationHistoryExt from 'tio-data/data/resources/notification-history.ext';
import observableDocumentExt from 'tio-data/data/resources/observable-document.ext';
import observationExt from 'tio-data/data/resources/observation.ext';
import observationDocumentExt from 'tio-data/data/resources/observation-document.ext';
import pcsCardExt from 'tio-data/data/resources/pcs-card.ext';
import pcsNetworkMerchantDetailExt from 'tio-data/data/resources/pcs-network-merchant-detail.ext';
import personExt from 'tio-data/data/resources/person.ext';
import planExt from 'tio-data/data/resources/plan.ext';
import postalAddressExt from 'tio-data/data/resources/postal-address.ext';
import pslfFormExt from 'tio-data/data/resources/pslf-form.ext';
import pslfProfileExt from 'tio-data/data/resources/pslf-profile.ext';
import pslfTemplateExt from 'tio-data/data/resources/pslf-template.ext';
import recommendationExt from 'tio-data/data/resources/recommendation.ext';
import reportsExt from 'tio-data/data/resources/reports.ext';
import roleViewExt from 'tio-data/data/resources/role-view.ext';
import strategyFinderResultExt from 'tio-data/data/resources/strategy-finder-result.ext';
import tasApplicationExt from 'tio-data/data/resources/tas-application.ext';
import tasApprovableExt from 'tio-data/data/resources/tas-approvable.ext';
import tasAssetExt from 'tio-data/data/resources/tas-asset.ext';
import tasAssistanceExt from 'tio-data/data/resources/tas-assistance.ext';
import tasCourseExt from 'tio-data/data/resources/tas-course.ext';
import tasDispatchExt from 'tio-data/data/resources/tas-dispatch.ext';
import tasEligibilityExt from 'tio-data/data/resources/tas-eligibility.ext';
import tasFieldExt from 'tio-data/data/resources/tas-field.ext';
import tasParticipantExt from 'tio-data/data/resources/tas-participant.ext';
import tasPaymentExt from 'tio-data/data/resources/tas-payment.ext';
import tasProgramInstanceExt from 'tio-data/data/resources/tas-program-instance.ext';
import tasProgramTemplateExt from 'tio-data/data/resources/tas-program-template.ext';
import tasProgramTemplateInstitutionExt from 'tio-data/data/resources/tas-program-template-institution.ext';
import userExt from 'tio-data/data/resources/user.ext';
import userRelationshipExt from 'tio-data/data/resources/user-relationship.ext';
import wellnessInsightsComponentDefinitionExt from 'tio-data/data/resources/wellness-insights-component-definition.ext';
import wellnessTrainExt from 'tio-data/data/resources/wellness-train.ext';

import commentableTrait from 'tio-data/data/traits/commentable.schema';
import digitalAssetTrait from 'tio-data/data/traits/digital-asset.schema';
import versionTrait from 'tio-data/data/traits/version.schema';

import type { TioSchemaManifest } from 'tio-data/store-factory';

export const schemas = [
  accountSchema,
  accountTransactionSchema,
  accountingInvoiceSchema,
  accountingLineItemSchema,
  accountingPaymentSchema,
  accountingReturnSchema,
  accountingTransactionSchema,
  agentSchema,
  aggregationAccountSchema,
  aggregationLoanChangeLogSchema,
  aggregationLoanForgivenessObservationSchema,
  aggregationUserSchema,
  agreementSchema,
  aiRecommendationSchema,
  answerProfileSchema,
  approvableSchema,
  assetSummarySchema,
  attachmentSchema,
  auditLogSchema,
  auditQueueSchema,
  authenticationLogSchema,
  bankTransactionSchema,
  bulkAchPaymentSchema,
  caffeinateCampaignSchema,
  caffeinateCampaignSubscriptionSchema,
  caffeinateMailingSchema,
  commandSchema,
  commentSchema,
  commentableSchema,
  companySchema,
  companyLpnSettingSchema,
  companySettingSchema,
  componentReviewCommentSchema,
  componentReviewThreadSchema,
  conditionSchema,
  conditionableSchema,
  contributionSchema,
  creditorSchema,
  customCompanyEmailTemplateSchema,
  dapipInstitutionCampusViewSchema,
  dependentSchema,
  digitalAssetSchema,
  eligibilityConditionSchema,
  eligibilityFileJobLogSchema,
  eligibilityFileJobLogEntrySchema,
  emailAddressSchema,
  emailTemplateSchema,
  employeeSchema,
  employeeAdditionSchema,
  employeePlanAccountSchema,
  employeeVersionSchema,
  enumSchema,
  enumPatternSchema,
  evaluationSchema,
  familySchema,
  familyInviteSchema,
  fieldableSchema,
  fileHistorySchema,
  fileHistoryLogSchema,
  financialInstitutionSchema,
  financialInstitutionPatternSchema,
  genericRelationshipSchema,
  incomingEmailLogSchema,
  inviteSchema,
  invoiceSchema,
  invoiceLineItemSchema,
  ledgerAccountSchema,
  ledgerEntrySchema,
  ledgerEventSchema,
  legacyAuthorizationResourceUserRelationshipTypeSchema,
  limitSchema,
  limitLedgerEntrySchema,
  loanSchema,
  loanResolutionSchema,
  loginSchema,
  lpnPageSchema,
  matchAssetSchema,
  matchCertificationSchema,
  matchParticipantSchema,
  matchPaymentSchema,
  matchPeriodSchema,
  matchPlanSchema,
  matchPlanRetirementPlanSchema,
  messageSchema,
  messageReceiptSchema,
  messageableSchema,
  notificationHistorySchema,
  observableSchema,
  observableAssetSchema,
  observableDocumentSchema,
  observableDocumentLogSchema,
  observationSchema,
  observationDocumentSchema,
  ownerSchema,
  partnerPolicySchema,
  paymentReturnSchema,
  paymentTransactionSchema,
  pcsAuthorizationSchema,
  pcsCardSchema,
  pcsCardEventSchema,
  pcsCardHolderSchema,
  pcsCompanySchema,
  pcsCompanyLoadSchema,
  pcsDisputeSchema,
  pcsLogicalCardUsageSchema,
  pcsMerchantSchema,
  pcsMerchantNetworkMerchantSchema,
  pcsNetworkMerchantSchema,
  pcsNetworkMerchantDetailSchema,
  pcsProgramSchema,
  pcsProgramSettingSchema,
  pcsProviderSchema,
  pcsProviderLoadSchema,
  pcsProviderSettingSchema,
  pcsTransactionSchema,
  personSchema,
  phoneNumberSchema,
  planSchema,
  planAuditPeriodSchema,
  planAuditScheduleSchema,
  postalAddressSchema,
  postalAddressableSchema,
  profileAttributeSchema,
  pslfAssetSchema,
  pslfFieldSchema,
  pslfFormSchema,
  pslfFormVersionSchema,
  pslfGroupSchema,
  pslfProfileSchema,
  pslfTemplateSchema,
  publicAssetSchema,
  rawFileDigitalAssetSchema,
  recommendationSchema,
  remoteEventSchema,
  reportTrackingSchema,
  reportsSchema,
  roleViewSchema,
  scheduleSchema,
  scholarshipSchema,
  searchSchema,
  searchDataPointSchema,
  searchDataSetSchema,
  searchDataSetMemberSchema,
  searchDataSetMemberFieldSchema,
  searchIndexDefinitionSchema,
  sqlDatasetSchema,
  strategyFinderResultSchema,
  tagSchema,
  taggableSchema,
  tasApplicationSchema,
  tasApprovableSchema,
  tasAssetSchema,
  tasAssistanceSchema,
  tasCourseSchema,
  tasDispatchSchema,
  tasEligibilitySchema,
  tasFieldSchema,
  tasFieldOptionSchema,
  tasGroupSchema,
  tasGroupingSchema,
  tasInvoiceSchema,
  tasParticipantSchema,
  tasPaymentSchema,
  tasPaymentAssistanceRecordSchema,
  tasProgramInstanceSchema,
  tasProgramInstanceVersionSchema,
  tasProgramLimitSchema,
  tasProgramTemplateSchema,
  tasProgramTemplateInstitutionSchema,
  tasProgramTemplateVersionSchema,
  tasUnaccreditedInstitutionSchema,
  tasUnifiedInstitutionSchema,
  thoughtBubbleFlowSchema,
  thoughtBubbleFlowInvocationSchema,
  thoughtBubbleStepSchema,
  tierSchema,
  tuitionAssistanceConfigSchema,
  userSchema,
  userRelationshipSchema,
  userRoleSchema,
  wellnessInsightsComponentDefinitionSchema,
  wellnessTrainSchema,
  workspaceSchema,
];

export const extensions = [
  accountExt,
  accountTransactionExt,
  accountingInvoiceExt,
  accountingLineItemExt,
  accountingPaymentExt,
  agentExt,
  aiRecommendationExt,
  answerProfileExt,
  assetSummaryExt,
  attachmentExt,
  bankTransactionExt,
  caffeinateMailingExt,
  commandExt,
  commentExt,
  companyLpnSettingExt,
  companySettingExt,
  componentReviewThreadExt,
  conditionExt,
  dependentExt,
  digitalAssetExt,
  eligibilityFileJobLogExt,
  emailAddressExt,
  employeeExt,
  employeeAdditionExt,
  evaluationExt,
  familyExt,
  inviteExt,
  invoiceExt,
  loanExt,
  loanResolutionExt,
  loginExt,
  lpnPageExt,
  matchParticipantExt,
  matchPlanExt,
  notificationHistoryExt,
  observableDocumentExt,
  observationExt,
  observationDocumentExt,
  pcsCardExt,
  pcsNetworkMerchantDetailExt,
  personExt,
  planExt,
  postalAddressExt,
  pslfFormExt,
  pslfProfileExt,
  pslfTemplateExt,
  recommendationExt,
  reportsExt,
  roleViewExt,
  strategyFinderResultExt,
  tasApplicationExt,
  tasApprovableExt,
  tasAssetExt,
  tasAssistanceExt,
  tasCourseExt,
  tasDispatchExt,
  tasEligibilityExt,
  tasFieldExt,
  tasParticipantExt,
  tasPaymentExt,
  tasProgramInstanceExt,
  tasProgramTemplateExt,
  tasProgramTemplateInstitutionExt,
  userExt,
  userRelationshipExt,
  wellnessInsightsComponentDefinitionExt,
  wellnessTrainExt,
];

export const traits = [commentableTrait, digitalAssetTrait, versionTrait];

/** Complete registration set: every schema, extension, and trait in tio-data. */
export const manifest: TioSchemaManifest = {
  schemas,
  traits,
  extensions,
};

export default manifest;
